import { NgModule } from '@angular/core';
import { LvtDrawerComponent } from './components/lvt-drawer/lvt-drawer.component';
import { LvtFeedCardComponent } from './components/lvt-feed-card/lvt-feed-card.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { SnButtonModule } from 'libs/ui/button/src/lib/button.module';
import { SnIconModule } from 'libs/ui/icon/src/lib/icon.module';
import { TranslationModule } from '@lib/translation';
import { SnDrawerModule } from '@lib/ui/drawer';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    // Material
    MatIconModule,
    MatListModule,
    MatSelectModule,
    // Libs
    TranslationModule,
    SnButtonModule,
    SnIconModule,
    SnDrawerModule,
  ],
  declarations: [LvtDrawerComponent, LvtFeedCardComponent],
  exports: [LvtDrawerComponent, LvtFeedCardComponent],
})
export class LvtModule {}
